// extracted by mini-css-extract-plugin
module.exports = {"container":"Collapse_container__1a-YC","collapse":"Collapse_collapse__1HnPi","panel":"Collapse_panel__2aMWb","panelText":"Collapse_panelText__2ukoN"};